import Link from 'next/link';
import type { ReactElement } from 'react';

import { ArrowIcon, PromobarWrapper } from './Promobar.styled';

export const Promobar = (): ReactElement => (
  <Link href="/sklep/teneryfa">
    <PromobarWrapper>
      🏝️ Zaplanuj wyjazd na Teneryfę szybciej i taniej
      <ArrowIcon viewBox="0 0 28 10">
        <path
          d="M0 5H26M26 5L21 1M26 5L21 9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </ArrowIcon>
    </PromobarWrapper>
  </Link>
);
